<template>
    <div class="ap-header">
        <div class="ap-title">
            <h1><slot>{{ $t(defaultHeaderKey) }}</slot></h1>
            <h2 v-if="companyInfo?.CompanyName!=null">{{ companyInfo?.CompanyName }}</h2>
        </div>
        <slot name="extra" />
    </div>
</template>

<script>
    import { useStore } from 'vuex'
    import { computed } from 'vue'
    export default {
        props: {
            i18nPathPrefixBase: { type: String, required: true }
        },
        computed: {
            i18nPathPrefix() { return `${this.i18nPathPrefixBase}.header` },
            defaultHeaderKey() { return `${this.i18nPathPrefixBase}.meta.title` }
        },
        setup() {
            const store = useStore()

            const companyInfo = computed(() => {
                return store.getters['studentWorksSettings/getCompanyInfo']
            })

            return { companyInfo }
        }
    }
</script>

<style lang="scss">
    @import '~styles/colors';

    .ap-header {
        padding: 0;
        position: relative;
        margin: 30px 0px;
        text-align: left;
        display: flex;
        flex-direction: row;

        .ap-title {

            h1 {
                margin: 0px;
                font-weight: 700;
                font-size: 32px;
                line-height: 32px;
                display: inline-block;
            }

            h2 {
                display: block;
                font-weight: 400;
                margin: 10px 0;
                font-size: 23px;
                line-height: 30px;
                width: 580px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }
</style>